import * as React from "react";

function SvgProfitWell(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 469.13 469.46"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <defs>
        <style>{".ProfitWell_svg__cls-2{fill:#21323b}"}</style>
      </defs>
      <g id="ProfitWell_svg__Layer_2" data-name="Layer 2">
        <g id="ProfitWell_svg__Layer_1-2" data-name="Layer 1">
          <path fill="#09b8a0" d="M295.41 239.58h55.68l-55.68-55.8v55.8z" />
          <path
            className="ProfitWell_svg__cls-2"
            d="M233.89 239.69h-44.21a5.8 5.8 0 01-5.8-5.79v-44.22a5.8 5.8 0 015.8-5.8h44.22a5.79 5.79 0 015.78 5.79v44.21a5.8 5.8 0 01-5.8 5.8m61.51-55.92l-47.58-47.58a28 28 0 00-8.08-5.63v.06a27.72 27.72 0 00-11.63-2.57h-32.66A27.78 27.78 0 00176 136l-40.08 40.08v.06a27.77 27.77 0 00-7.78 19.29v88.42a27.8 27.8 0 008.5 20.15L172 339.36a7 7 0 0011.78-3.8h.12v-34.28a5.79 5.79 0 015.79-5.79h38.38a27.78 27.78 0 0019.75-8.2h.06l39-39v-.09c.41-.39.78-.82 1.17-1.23l7.37-7.41zM351.1 326.47a.86.86 0 000-.16v-86.73h-55.69v86.73c0 .38-.06.76-.06 1.14a14 14 0 0013.95 13.95h27.9a13.94 13.94 0 0013.9-13z"
          />
          <path fill="none" d="M0 0h1399.13v469.46H0z" />
        </g>
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgProfitWell);
